import React, { useEffect } from "react";
import { useRef, useState } from "react";
import { Form, Button, Row, Col, Spinner, Table } from "react-bootstrap";
import API_BASE_URL from "../../config";
import { authFetch } from "../../utility/authFetch";

function PatientTestReg({ setLoader, setSearch, search, id }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [name, setName] = useState("");
  const [selectedTest, setSelectedTest] = useState([]);
  const [paymentMode, setPaymentMode] = useState("");
  const [discount, setDiscount] = useState("");

  useEffect(() => {
    const fetchTest = async () => {
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/patient-test-reg?id=${id}`
        );
        const result = await response.json();
        setName(result.tests[0].name);
        setSelectedTest(result.tests[0].tests);
      } catch (error) {
        console.error("Error fetching patient:", error);
      }
    };

    fetchTest();
  }, [search, id]);

  const totalAmount = selectedTest.reduce(
    (sum, test) => sum + Number(test.rate || 0),
    0
  );

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    const url = `${API_BASE_URL}/api/tests-payment`;

    selectedTest.forEach((t) => {
      formData.append(
        "tests[]",
        JSON.stringify({ test_id: t.id, rate: t.rate })
      );
    });

    formData.append("vdid", id);
    formData.append("paymentMode", paymentMode);
    formData.append("gross_total", totalAmount);
    formData.append("discount", discount);

    const method = "POST";

    try {
      const response = await authFetch(url, {
        method,
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert("Follow Up registered successfully");
        setIsSubmitting(false);
        setSelectedTest([]);
        setDiscount("");
        setPaymentMode("");
        setLoader(false);
        setSearch(true);
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  return (
    <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container bg-white p-4 rounded shadow-sm">
        <div className="d-flex flex-row justify-content-between">
          <h5 className="mb-3">Follow Up Registration</h5>
          <Button onClick={() => setSearch(true)} variant="warning">
            Go Back
          </Button>
        </div>
        <Form onSubmit={handleSubmit}>
          <Row className="align-items-end g-3">
            <Col md={4}>
              <Form.Group className="mb-3" controlId="formPatientName">
                <Form.Label>
                  Patient Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  required
                  value={name}
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3" controlId="formPaymentMode">
                <Form.Label>Payment Mode</Form.Label>
                <Form.Select
                  aria-label="Category"
                  name="paymentMode"
                  required
                  value={paymentMode}
                  onChange={(e) => setPaymentMode(e.target.value)}
                  readOnly={paymentMode === "N/A"}
                >
                  <option value="Cash">Cash</option>
                  <option value="Card">Card</option>
                  <option value="UPI">UPI</option>
                  <option value="N/A">N/A</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          {selectedTest.length > 0 && (
            <Table bordered hover responsive className="mt-3">
              <thead>
                <tr>
                  <th>Test Name</th>
                  <th>Location</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {selectedTest.map((test, index) => (
                  <tr key={index}>
                    <td>{test.test_name}</td>
                    <td>{test.location}</td>
                    <td>
                      <Form.Control
                        type="number"
                        value={test.rate}
                        onChange={(e) => {
                          const updated = [...selectedTest];
                          updated[index].rate = e.target.value;
                          setSelectedTest(updated);
                        }}
                      />
                    </td>
                  </tr>
                ))}
                <tr className="fw-bold">
                  <td colSpan={2} className="text-end">
                    Total
                  </td>
                  <td>{totalAmount.toFixed(2)}</td>
                </tr>
                <tr className="fw-bold">
                  <td colSpan={2} className="text-end">
                    Discount
                  </td>
                  <td>
                    <Col md={4}>
                      <Form.Group controlId="formDiscount">
                        <Form.Control
                          type="number"
                          name="discount"
                          value={discount}
                          onChange={(e) => setDiscount(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </td>
                </tr>
                <tr className="fw-bold table-secondary">
                  <td colSpan={2} className="text-end">
                    Net Total
                  </td>
                  <td>{(totalAmount - discount).toFixed(2)}</td>
                </tr>
              </tbody>
            </Table>
          )}

          <Button variant="primary" type="submit" disabled={isSubmitting}>
            SUBMIT
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default PatientTestReg;
